export default (outcome1, outcome2) => outcome1.op - outcome2.op;
